"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NullEventProcessor {
    close() { }
    async flush() {
        // empty comment to keep ts and eslint happy
    }
    sendEvent() { }
}
exports.default = NullEventProcessor;
//# sourceMappingURL=NullEventProcessor.js.map